import React, { useMemo } from 'react';
import styles from './PageShownInProviderCurrencyWarningOverlay.module.scss';
import { useCurrencyContext } from 'app/contexts/Currency/CurrencyContext';

export const PageShownInProviderCurrencyWarningOverlay = (): React.ReactNode => {
  const currencyContext = useCurrencyContext();
  const text = useMemo(() => {
    if (currencyContext.isReportsView) {
      return 'processing';
    }
    return 'provider';
  }, [currencyContext.isReportsView]);

  return (
    <div className={styles.container}>
      <div className={styles.noticeTitle}>Notice:</div>
      <div>This page is shown in your {text} currency.</div>
    </div>
  );
};
